import { useState, useEffect } from 'react';

export const useColorMode = (): string => {
  const [theme, setTheme] = useState<'light' | 'dark' | 'highContrast'>(
    'light'
  );

  useEffect(() => {
    const mediaQueryDark = window.matchMedia('(prefers-color-scheme: dark)');
    const mediaQueryHighContrast = window.matchMedia('(forced-colors: active)');

    const updateTheme = () => {
      if (mediaQueryHighContrast.matches) {
        setTheme('highContrast');
      } else if (mediaQueryDark.matches) {
        setTheme('dark');
      } else {
        setTheme('light');
      }
    };

    mediaQueryDark.addEventListener('change', updateTheme);
    mediaQueryHighContrast.addEventListener('change', updateTheme);

    // Initial check
    updateTheme();

    return () => {
      mediaQueryDark.removeEventListener('change', updateTheme);
      mediaQueryHighContrast.removeEventListener('change', updateTheme);
    };
  }, []);

  return theme;
};
